import api from './api';

export type IcebreakerChannel = 'email' | 'linkedin';
export type EnrichmentSource = 'research' | 'website' | 'signal' | 'manual';

export interface IcebreakerContact {
  firstName?: string;
  lastName?: string;
  jobTitle?: string;
  company?: string;
  linkedInUrl?: string;
  website?: string;
}

export interface EnrichmentResult {
  research?: string;
  websiteText?: string;
  websiteSummary?: string;
  signalText?: string;
  signalUrl?: string;
  sourcesUsed: EnrichmentSource[];
  warnings: string[];
}

export interface IcebreakerVariant {
  channel: IcebreakerChannel;
  label: string;
  angle?: string;
  subject?: string;
  icebreaker: string;
  fullMessage: string;
}

export interface GenerateResult {
  variants: IcebreakerVariant[];
  contextUsed: string[];
  provider: string;
  model: string;
}

export interface IcebreakerQualityIssue {
  level: 'warn' | 'info';
  code: string;
  message: string;
}

export interface IcebreakerQualityResult {
  score: number;
  rating: 'gut' | 'ok' | 'schwach';
  issues: IcebreakerQualityIssue[];
}

export interface AssessQualityInput {
  text: string;
  kind?: IcebreakerChannel;
  contact?: { firstName?: string; company?: string };
}

export interface RunInput {
  contact: IcebreakerContact;
  channels: IcebreakerChannel[];
  variantCount?: number;
  tone?: string;
  language?: string;
  goal?: string;
  signalText?: string;
  manualContext?: string;
  research?: string;
  websiteSummary?: string;
  autoSources?: EnrichmentSource[];
  icpId?: string;
  personaId?: string;
  offerId?: string;
}

class IcebreakerService {
  async enrich(input: { contact: IcebreakerContact; sources?: EnrichmentSource[] }): Promise<EnrichmentResult> {
    const response = await api.post('/icebreaker/enrich', input);
    return response.data;
  }

  async generate(input: RunInput): Promise<GenerateResult> {
    const response = await api.post('/icebreaker/generate', input);
    return response.data;
  }

  async run(input: RunInput): Promise<GenerateResult & { enrichment: EnrichmentResult }> {
    const response = await api.post('/icebreaker/run', input);
    return response.data;
  }

  async assessQuality(input: AssessQualityInput): Promise<IcebreakerQualityResult> {
    const response = await api.post('/icebreaker/assess', input);
    return response.data;
  }
}

const icebreakerService = new IcebreakerService();
export default icebreakerService;
